import { render, staticRenderFns } from "./CategoriasList.vue?vue&type=template&id=937e9712&scoped=true&"
import script from "./CategoriasList.vue?vue&type=script&lang=js&"
export * from "./CategoriasList.vue?vue&type=script&lang=js&"
import style0 from "./CategoriasList.vue?vue&type=style&index=0&id=937e9712&lang=scss&scoped=true&"
import style1 from "./CategoriasList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937e9712",
  null
  
)

export default component.exports